import { render, staticRenderFns } from "./app-install-list.vue?vue&type=template&id=08927e64&scoped=true&"
import script from "./app-install-list.vue?vue&type=script&lang=js&"
export * from "./app-install-list.vue?vue&type=script&lang=js&"
import style0 from "./app-install-list.vue?vue&type=style&index=0&id=08927e64&prod&scoped=true&lang=less&"
import style1 from "./app-install-list.vue?vue&type=style&index=1&id=08927e64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08927e64",
  null
  
)

export default component.exports